<div class="m-5">
    <img class="img-responsive center-block" src="{{logoCompany}}" />
</div>
